'use client';
import React from 'react';
import { TFactoryOrderSection, cn } from 'types';
import { Button } from '../../button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Icon, IconType } from '../../icons';

export const formatDate = (value: Date, showOnCart: boolean = false, yearFirst: boolean = false) => {
  let dateValue = new Date(value);
  if (isNaN(dateValue.getTime())) {
    dateValue = new Date();
  }
  const month = dateValue.getMonth() + 1;
  const date = dateValue.getDate();
  const year = dateValue.getFullYear();
  if (showOnCart)
    return String((date >= 10 ? date : '0' + date) + '.' + (month >= 10 ? month : '0' + month) + '.' + year);
  else return String((month >= 10 ? month : '0' + month) + '-' + (date >= 10 ? date : '0' + date) + '-' + year);
};

export const FactoryOrderSection = React.forwardRef((props: TFactoryOrderSection, ref: React.Ref<HTMLDivElement>) => {
  const [expectedProductionDateState, setExpectedProductionDateState] = React.useState<Date>(
    new Date(props.expectedProductionDate)
  );

  React.useEffect(() => {
    setExpectedProductionDateState(new Date(props.expectedProductionDate));
  }, [props.expectedProductionDate]);

  const onChangeProdDate = (date: Date | null) => {
    if (date) {
      setExpectedProductionDateState(date);
    }
  };

  const onLagreClick = () => {
    if (props?.onSaveFactoryOrder) {
      props.onSaveFactoryOrder(formatDate(expectedProductionDateState));
    }
  };
  return (
    <div className="w-full flex flex-col gap-4" ref={ref}>
      {!props.isProdDateDisabled && <h3 className="text-lg/[170%] font-extrabold">Bestill bil fra fabrikk</h3>}
      <div className=" w-full grid grid-cols-[3fr_1fr_1fr] gap-4">
        <div className="relative w-full">
          <DatePicker
            selected={expectedProductionDateState}
            onChange={onChangeProdDate}
            onKeyDown={(e: React.KeyboardEvent) => e.preventDefault()}
            disabled={props.isProdDateDisabled}
            dateFormat="dd.MM.yyyy"
            minDate={new Date()}
            className={cn(
              'w-full bg-white border border-neutralPlus px-4 py-3 rounded-lg',
              'enabled:hover:bg-lightGrey enabled:hover:border-black',
              'text-base/[175%] font-semibold',
              props.isProdDateDisabled && 'text-neutralPlus disabled:bg-lightGrey disabled:border-neutralGrey'
            )}
            wrapperClassName="w-full"
          />
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <Icon icon={IconType.NewNextCalendar} width={24} height={24} />
          </div>
        </div>
        <Button variant="teal" className="w-full" isLoading={props?.isLoading} onClick={onLagreClick}>
          <span>Lagre</span>
        </Button>
        <Button
          className="w-full"
          onClick={() => props.setIsFactoryOrderOpen(false)}
          variant={'teal'}
          appearance="outline"
        >
          <span>Avbryt</span>
        </Button>
      </div>
    </div>
  );
});
